import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {IndecxSurveyService} from '@services/indecx-survey.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { LoadingGenericoComponent } from '../loading-generico/loading-generico.component';

@Component({
    selector: 'app-indecx-surfey',
    templateUrl: './indecx-surfey.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent]
})
export class IndecxSurfeyComponent implements OnInit, OnDestroy {

  public loadingGenerico: any = false;
  public destroyed$ = new Subject<void>();

  public injectScript(indecxSurveyParameters) {

    const script = `
      (function(){
        var c = {
          "key": "${indecxSurveyParameters.dadosPesquisa.keyWidget}",
          "action": "${indecxSurveyParameters.dadosPesquisa.actionWidget}",
          "name": "${indecxSurveyParameters.usuarioLogado.nomeUsuario}",
          "email": "${indecxSurveyParameters.usuarioLogado.emailUsuario}",
          "phone": "${indecxSurveyParameters.usuarioLogado.telefoneUsuario}",
          "indicators": {
            "cnpj": "${indecxSurveyParameters.indicadores.cnpj}",
            "contrato": "${indecxSurveyParameters.indicadores.contrato}",
            "razao_social": "${indecxSurveyParameters.indicadores.razaoSocial}",
            "tipo_interlocutor": "${indecxSurveyParameters.indicadores.tipoInterlocutor}",
            "cpf_usuario": "${indecxSurveyParameters.usuarioLogado.cpfUsuario}"
          }
        };
        var e;
        if (document.getElementById("script-indecx")) { return }
        e = document.createElement("script");
        e.id = "script-indecx";
        e.src = "${indecxSurveyParameters.dadosPesquisa.urlPesquisa}";
        e.type = "text/javascript";
        e.async = true;
        e.onload = e.onreadystatechange = function() {
          var h = this.readyState;
          if (h && h != "complete" && h != "loaded") { return }
          try {
            IndeCX(c);
          } catch (i) {}
        };
        document.body.appendChild(e);
      }())
    `;
    const scriptElement = document.createElement('script');
    scriptElement.innerHTML = script;
    document.body.appendChild(scriptElement);
  }

  constructor(private readonly indecxSurveyService: IndecxSurveyService) {
  }

  ngOnInit(): void {
    this.getIntecxSurveyParameters();
  }

  public getIntecxSurveyParameters() {
    this.loadingGenerico = true;

    this.indecxSurveyService.getParameters()
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (success: any) => {
          const indexSurveyParameters = success.response;
          this.injectScript(indexSurveyParameters);
        },
        error: (error) => {
          console.log(error);
          this.loadingGenerico = false;
          throw new Error(error);
        },
        complete: () => {
          this.loadingGenerico = false;
        }
      });
  }

  ngOnDestroy(): void {

    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
